import { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../routes/routes_name";

const RedirectingPage = () => {
   useEffect(() => {
           const baseUrl = process.env.REACT_APP_PORT
           setTimeout(() => {
               window.location.href = `${baseUrl}/login`
           }, 1500);
       }, [])
    return (
        <main>
            <div className="container"></div>
            <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
                <a className="btn" href="">Redirecting...</a>
                <img style={{ height: "500px" }} src="assets/img/redirecting.svg" className="img-fluid py-5" alt="Page Not Found" />
                <div className="credits">
                    Designed by <a href="https://kemenag.go.id/">Pusdatin Kemenag</a>
                </div>
            </section>
        </main >
    )
}
export default RedirectingPage